
import { Component, Vue } from 'vue-property-decorator'
import { ReconfigureMailAddressesApi } from '@/api/methods/ReconfigureMailAddressesApi'
import { ApiNotFoundAppError } from '@/models/AppErrorClasses'

/**
 * メールアドレス更新ページ
 *   認証メールからの遷移先クッションページのため表示はしない
 */
@Component
export default class ReconfigureMailUpdate extends Vue {
  /**
   * 開始時の処理(自動遷移を行うため全てここで処理する)
   */
  private async created(): Promise<void> {
    const token = this.$route.query.token
    if (!token || typeof token !== 'string') {
      // トークン指定不正時は認証エラー画面へ遷移
      await this.$router.push('/student/reconfigureMail/invalid')
      return
    }

    try {
      // メールアドレス更新
      await ReconfigureMailAddressesApi.updateMailAddress(token)
    } catch (error) {
      // トークン期限切れ時の遷移
      if (error instanceof ApiNotFoundAppError) {
        this.$loading.complete()
        await this.$router.push('/student/reconfigureMail/invalid')
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    // トークン確認成功時は完了画面に遷移
    await this.$router.push('/student/reconfigureMail/complete')
  }
}
